import emailjs from '@emailjs/browser';

const CONFIG_KEY = 'kzerodiary_emailjs_config';

// Configuração padrão pré-definida
const CONFIG_PADRAO = {
  serviceId:    'service_whqzwnc',
  templateId:   'template_sldaetf',
  templateIdAta: 'template_0xcjfrq', // template dedicado para envio de atas
  publicKey:    'yakmFSnOegxws2ic7',
  ativo:        true,
};

// Carrega configuração — credenciais sempre vêm do CONFIG_PADRAO, só ativo pode ser alterado
export function carregarConfigEmail() {
  try {
    const raw = localStorage.getItem(CONFIG_KEY);
    const salvo = raw ? JSON.parse(raw) : {};
    return {
      ...CONFIG_PADRAO,
      ativo: salvo.ativo !== undefined ? salvo.ativo : true,
    };
  } catch {
    return CONFIG_PADRAO;
  }
}

// Salva configuração do EmailJS
export function salvarConfigEmail(config) {
  localStorage.setItem(CONFIG_KEY, JSON.stringify(config));
}

// Envia notificação de backup por email (sem anexo — plano gratuito EmailJS não suporta)
export async function enviarBackupPorEmail(snapshot) {
  const config = carregarConfigEmail();
  if (!config.ativo || !config.serviceId || !config.templateId || !config.publicKey) {
    return { ok: false, erro: 'Email não configurado.' };
  }

  const dadosSemAnexos = limparAnexosParaEmail(snapshot.dados);
  const jsonObj = { versao: '2.0', geradoEm: snapshot.geradoEm, dados: dadosSemAnexos };
  const jsonStr = JSON.stringify(jsonObj, null, 2);

  const dataFormatada = snapshot.data.split('-').reverse().join('/');
  const tamanhoKb    = (new Blob([jsonStr]).size / 1024).toFixed(1);
  const d            = snapshot.dados;

  const resumo = [
    `Clientes: ${d.clientes?.length || 0}`,
    `Agendamentos: ${d.agendamentos?.length || 0}`,
    `Lancamentos: ${d.fluxoCaixa?.length || 0}`,
    `Reembolsos: ${d.reembolsos?.length || 0}`,
    `Atas: ${d.atas?.length || 0}`,
    `Propostas: ${d.propostas?.length || 0}`,
    `Total: ${snapshot.totalRegistros} registros - ${tamanhoKb} KB`,
  ].join(' | ');

  // Inclui JSON no email — trunca se passar de 40KB (limite seguro EmailJS free tier)
  const LIMITE_BYTES = 40 * 1024;
  const jsonParaEmail = new Blob([jsonStr]).size <= LIMITE_BYTES
    ? jsonStr
    : jsonStr.substring(0, LIMITE_BYTES) + '\n\n[... TRUNCADO — tamanho excede 40KB. Baixe o backup completo pelo sistema.]';

  try {
    await emailjs.send(
      config.serviceId,
      config.templateId,
      {
        data_backup:    dataFormatada,
        hora_backup:    snapshot.hora,
        tipo_backup:    snapshot.tipo === 'automatico' ? 'Automatico (21h)' : 'Manual',
        resumo,
        tamanho_arquivo: `${tamanhoKb} KB`,
        conteudo_json:  jsonParaEmail,
        destinatario:   'bianca@kzeroconsultoria.com.br',
      },
      { publicKey: config.publicKey }
    );
    return { ok: true };
  } catch (err) {
    return { ok: false, erro: err?.text || err?.message || 'Erro desconhecido.' };
  }
}

// Remove dados base64 de anexos para não estourar o limite de email
function limparAnexosParaEmail(dados) {
  const limpar = (arr) => (arr || []).map(item => ({
    ...item,
    anexos: (item.anexos || []).map(a => ({ nome: a.nome, dados: '[omitido]' })),
    anexo: item.anexo ? '[omitido]' : undefined,
  }));

  return {
    ...dados,
    clientes:  limpar(dados.clientes),
    anotacoes: limpar(dados.anotacoes),
    reembolsos: limpar(dados.reembolsos),
    atas:      limpar(dados.atas),
    propostas: limpar(dados.propostas),
  };
}
